import mapKnownValues from "@/utils/mapKnownValues";
import Property from "@/classes/property";
import Organization from "@/classes/organization";
import Role, { RoleAPIResponse, RoleEnum } from "@/classes/role";
import formatNumberAsCurrency from "@/utils/formatNumberAsCurrency";

export type UserAPIResponse = {
  id: string;
  nameFirst: string;
  nameLast: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  isPaymentFailure: boolean;
  zip: string;
  organization: string;
  property: string;
  email: string;
  rfid: string;
  stationInProgress: string;
  stripeCustomerId: string;
  isCardOnFile: boolean;
  forceResetPassword: true;
  phone: string;
  isSubscribed: boolean;
  isTracked: boolean;
  token: string;
  role: RoleAPIResponse | null;
  reloadAmount: number; // In cents
};

export default class User {
  id = "";
  isConfirmed = false;
  isPaymentFailure = false;
  nameFirst = "";
  nameLast = "";
  address1 = "";
  address2 = "";
  city = "";
  state = "";
  zip = "";
  email = "";
  rfid = "";
  stationInProgress = "";
  stripeCustomerId = "";
  isCardOnFile = true;
  forceResetPassword = true;
  phone = "";
  isSubscribed = true;
  isTracked = true;
  token = "";
  reloadAmount = 0;
  role: Role | null = null;

  // Doesn't come back from API
  organization: Organization | null = null;
  property: Property | null = null;

  constructor(params: Partial<User> = {}) {
    mapKnownValues(this, params);
  }

  get reloadAmountDisplay() {
    return formatNumberAsCurrency(this.reloadAmount / 100);
  }

  get isAdmin() {
    return [RoleEnum.Admin, RoleEnum.AdminReadOnly].includes(this.role?.rName || ("" as any));
  }

  get isNotUser() {
    return [RoleEnum.User].includes(this.role?.rName || ("" as any));
  }

  get roleDisplay() {
    return this.role?.rName || "";
  }

  get name() {
    if (!this.nameFirst && !this.nameLast) {
      return "******";
    }
    return `${this.nameFirst} ${this.nameLast || ""}`;
  }

  static fromAPI(response: UserAPIResponse, organization: Organization | undefined, property: Property | undefined) {
    return new User({
      ...response,
      role: response.role ? Role.fromAPI(response.role) : null,
      property,
      organization
    });
  }
}
